import { render, staticRenderFns } from "./CytomineViewer.vue?vue&type=template&id=54bcdbac&scoped=true"
import script from "./CytomineViewer.vue?vue&type=script&lang=js"
export * from "./CytomineViewer.vue?vue&type=script&lang=js"
import style0 from "./CytomineViewer.vue?vue&type=style&index=0&id=54bcdbac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bcdbac",
  null
  
)

export default component.exports